
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class QualityInspectionTemplateDetailsGrid extends Serenity.EntityGrid<QualityInspectionTemplateDetailsRow, any> {
        protected getColumnsKey() { return 'Administration.QualityInspectionTemplateDetails'; }
        protected getDialogType() { return QualityInspectionTemplateDetailsDialog; }
        protected getIdProperty() { return QualityInspectionTemplateDetailsRow.idProperty; }
        protected getInsertPermission() { return QualityInspectionTemplateDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return QualityInspectionTemplateDetailsRow.localTextPrefix; }
        protected getService() { return QualityInspectionTemplateDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}